import { useState } from "react";
import "../styles/layout.css"

function Input({
  type,
  name,
  id,
  placeholder,
  value,
  onChange,
  maxLength,
  minLength
}) {
  const [focused, setFocused] = useState(false);

  return (
    <div className="labelInput">
      <label
        htmlFor={name}
        className={focused || value ? "visible" : ""}
      >
        {placeholder}
      </label>

      <input
        type={type}
        id={name}
        name={name}
        placeholder={focused ? "" : placeholder}
        value={value}
        maxLength={maxLength}
        minLength={minLength}
        required
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => !value && setFocused(false)}
      />
    </div>
  );
}

export default Input;
